module.exports = __webpack_public_path__ + "img/GSF_Sketch-Family-Color-00.323af01f.jpg";